module.exports = {
    dashboard: "Wand",
    voltage_profile: "Spannungsprofil",
    current_profile: "Aktuelles Profil",
    active_power_profile: "Wirkleistungsprofil",
    reactive_power_profile: "Blindleistungsprofil",
    apparent_power_profile: "Scheinleistungsprofil",
    energy_import_profile: "Energieimportprofil",
    energy_export_profile: "Energieexportprofil",
    realtime_voltage: "Echtzeit-Spannungsprofil",
    realtime_current: "Echtzeit-Flussprofil",
    realtime_active_power: "Wirkleistungsprofil in Echtzeit",
    realtime_reactive_power: "Blindleistungsprofil in Echtzeit",
    realtime_apparent_power: "Scheinbares Echtzeit-Leistungsprofil",
    realtime_energy_import_profile: "Stromverbrauch in Echtzeit",
    realtime_energy_export_profile: "Echtzeit-Stromversorgung",
    hourly_active_energy: "Stündliche Gesamtenergie",
    daily_active_energy: "Tägliche Gesamtenergie",
    monthly_active_energy: "Monatliche Gesamtenergie",
    hourly_reactive_energy: "Stündliche Blindleistung",
    daily_reactive_energy: "Tägliche Blindleistung",
    monthly_reactive_energy: "Monatliche Blindleistung",
    appliances_imprints: "Gerätefingerabdrücke",
    appliances_energy: "Energieverbrauch anerkannter Geräte",
    appliances_timeline: "Geräte-Timeline",
    appliances_run_profile: "Wirkleistungsprofil mit Geräten",
    imprints_map: "Appliance-Fingerabdruckkarte",
    edit_profile: "Profil bearbeiten",
    dashboard_settings: "Dashboard-Einstellungen",
    statistics_report: "Statistischer Bericht",
    graphs_types: "Arten von Graphen",
    active_energy_report: "Aktiver Energiebericht",
    reactive_energy_report: "Blindleistungsbericht",
    location: "Standorte",
    local_change_password: "Ändern Sie das lokale Passwort",
    monitoring: "Überwachung",
    phase_selection: "Auswahlphase",
    appliance_properties: "Geräteeigenschaften",
    energy_edit: "Energieeinstellungen",
    dashboard_merito_recognition: "Wand",
    dashboard_disconnector: "Wand Disconnector",
    dashboard_precision: "Wand Applied Precision",
    disconnector_timeline: "Zeitleiste",
    disconnector_energy_profile: "Energieprofil",
    lora_settings: "LoRa die Einstellungen",
    basic: "Basic",
    details: "Einzelheiten",
    data: "Data",
    basic_settinsg: "Grundeinstellungen",
    details_settings: "Detaileinstellungen",
    data_structure_settinsg: "Datenstruktureinstellungen",
    timers: "Timer",
    energy_scalers: "Energieskalen",
    radio: "Radio",
    create_first_test_case: "Erstellen Sie Ihren ersten Testfall",
    add_new_test_case: "Neuen Testfall hinzufügen",
    edit_test_case: "Testfall bearbeiten",
    generator: "Generator",
    test_conditions: "Test-Bedingungen",
    accutest_profile: "Testprofil",
    no_test_was_performed: "Es wurde kein Test durchgeführt",
    test_case: "Testfall",
    relative_error_chart: "Diagramm des relativen Fehlers über Testfälle",
    accutest_results: "Testergebnisse",
    accutest_testing: "Testprozess",
    start_testing_process: "Starten Sie den Testprozess",
    test_case_result: "Ergebnis des Testfalls",
    testing_in_progress: "Test läuft",
    start_another_testing_process: "Starten Sie einen weiteren Testprozess",
    integration: "Integration",
    generated: "Generiert",
    expiration: "Ablauf",
    token: "Token",
    note: "Hinweis",
    token_validity: "Token-Gültigkeit",
    valid_tokens: "Gültige Token",
    invalid_tokens: "Ungültige Token",
    generate_first_token: "Generieren Sie das erste Token",
    active_energy_15min: "Aktive Energie in 15 Minuten",
    maximum_active_energy_15min: "Maximale Wirkleistung in 15 Minuten",
    wifi_settings: "Wlan einstellungen",
    device_settings: "Geräteeinstellungen",
    report: "Anwendung Report",
    controller_state: "Relaisstatus der Anwendung Controller",
    no_disconnector_selected: "Kein disconnector ausgewählt",
    controller_timeline: "Zeitleiste der Anwendung Controller",
    rising_shapes: "Steigende Formen von Geräten",
    falling_shapes: "Fallende Formen von Geräten",
    firmware_upgrade: "Firmware-Aktualisierung",
    firmware_up_to_date: "Die Firmware ist auf dem neuesten Stand",
    firmware_upgrade_available: "Upgrade ist verfügbar",
    firmware_not_available: "Upgrade nicht verfügbar",
    settings: "Einstellungen",
    new_switch: "Neuer Schalter",
    map: "Karte",
    upload_new_map: "Laden Sie Ihre neue Karte hoch",
    control_map: "Kontrollkarte",
    uploading: "Hochladen",
    loading: "Wird geladen",
    notifications: "Benachrichtigungen",
    add_notification_pair: "Benachrichtigungspaar hinzufügen",
    paired_notifications: "Gepaarte Benachrichtigungen",
    notify_device_status: "Gerätestatus",
    notify_anomaly: "Anomalie",
    anomaly_models: "Anomaliemodelle",
    user_manager: "Anwendung UserManager",
    select_group: "Gerätegruppe"
}